module.exports = __webpack_public_path__ + "static/img/3.3a99c2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/裤子/3.png
// module id = Lygm
// module chunks = 0